module.exports = __webpack_public_path__ + "img/ruler-icon.7b085f80.svg";